// Paletas precargadas de "Esencial" (civil íntimo).
const FUENTES = {
  display: '"Spectral", Georgia, serif',
  cuerpo: '"Work Sans", system-ui, sans-serif',
};

export const paletas = [
  {
    clave: "lino",
    nombre: "Lino",
    tema: {
      colores: {
        fondo: "#FAF8F5",
        fondoAlt: "#F2EEE7",
        texto: "#2B2925",
        textoSuave: "#5C574F",
        textoTenue: "#948E84",
        primario: "#4A4640",
        primarioSuave: "#EAE5DC",
        acento: "#A98A6B",
        borde: "rgba(74, 70, 64, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "grafito",
    nombre: "Grafito",
    tema: {
      colores: {
        fondo: "#F5F5F4",
        fondoAlt: "#EBEBE9",
        texto: "#242426",
        textoSuave: "#535356",
        textoTenue: "#8E8E92",
        primario: "#313133",
        primarioSuave: "#E4E4E1",
        acento: "#7E6C5D",
        borde: "rgba(49, 49, 51, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "rosario",
    nombre: "Rosario",
    tema: {
      colores: {
        fondo: "#FAF4F2",
        fondoAlt: "#F4E9E6",
        texto: "#33242A",
        textoSuave: "#644A52",
        textoTenue: "#9C858B",
        primario: "#7A4A4A",
        primarioSuave: "#F0E0DE",
        acento: "#B98A6B",
        borde: "rgba(122, 74, 74, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
];
